/**
 * The one guard for any URL that came from a third-party site or ad library before it reaches an `src` or
 * `href`: only absolute http(s) URLs pass. `javascript:`, `data:`, `blob:`, protocol-relative and relative
 * values are dropped, never rendered. Returns the normalised href, or null.
 */
export function safeHttpUrl(value: string | null | undefined): string | null {
  if (!value) return null;
  try {
    const url = new URL(value.trim());
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : null;
  } catch {
    return null;
  }
}
